<template>
  <v-card :class="['pa-4', 'd-flex', 'flex-column', 'fill-height', { 'mb-4': !readonly, 'mt-2': !readonly }]" :style="!readonly ? 'width: 100%' : ''" outlined>
    <div class="d-flex align-center mb-2">
      <Icon :icon="icon" :small="false" class="mr-1"/>
      <span class="subtitle-1">{{ label }}</span>
    </div>
    <v-row
      v-for="(setting, idx) in settings"
      :key="idx"
      :class="!readonly ? 'mt-0' : ''"
    >
      <v-col v-if="!readonly" cols="12">
        <v-checkbox
        :label="setting.label"
        v-model="setting.value"
        hide-details
        class="mt-0"
        @change="val => $emit('setting-changed', { index: idx, value: val })"/>
      </v-col>
      <v-col v-if="readonly" cols="10" class="pt-2">
        {{ setting.label }}:
      </v-col>
      <v-spacer/>
      <v-col v-if="readonly" align="right" cols="2" class="pt-2">
        <Icon
        :icon="setting.value ? 'mdi-checkbox-marked-circle' : 'mdi-close'"
        :iconColor="setting.value ? 'success' : 'error'"
        />
      </v-col>
    </v-row>
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'MobileAppSettingsCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    settings: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
